export { default as layout } from '@app/layouts/app-layout-empty';

export { default as Login } from './login';

export const meta = {};
